import { Grid, TextField } from '@mui/material';
import { useStyles } from './styles/FormDisabledText.styles';

/** Text */
interface DisabledTextInput {
    label: string;
    value: string;
    size?: number;
}

export const FormDisabledText = ({ label, value, size }: DisabledTextInput) => {
    const classes = useStyles();

    return (
        <Grid item md={size ?? 6} xs={12} sm={12} className={classes.textInputWrapper}>
            <TextField label={label} variant='outlined' className={classes.textInput} value={value} disabled />
        </Grid>
    );
};
